export const DROPDOWN_VIEWPORT_PADDING = 8;
export const VERTICAL_OFFSET = 48;

export type CenteredDropdownAlignPoints = ['tc', 'tc'] | ['tl', 'tl'] | ['tr', 'tr'];

export type ClickDropdownPlacement = 'bottomLeft' | 'bottomRight';

export const willOverflowViewportLeft = (left: number) => left < DROPDOWN_VIEWPORT_PADDING;

export const willOverflowViewportRight = (left: number, menuWidth: number) =>
  left + menuWidth + DROPDOWN_VIEWPORT_PADDING > window.innerWidth;

export const getClickDropdownPlacement = (clientX: number, menuWidth: number): ClickDropdownPlacement =>
  willOverflowViewportRight(clientX, menuWidth) ? 'bottomRight' : 'bottomLeft';

export const getCenteredDropdownAlignPoints = (trigger: DOMRect, menuWidth: number): CenteredDropdownAlignPoints => {
  const centerLeft = trigger.left + trigger.width / 2 - menuWidth / 2;

  if (willOverflowViewportLeft(centerLeft)) {
    return ['tl', 'tl'];
  }

  if (willOverflowViewportRight(centerLeft, menuWidth)) {
    return ['tr', 'tr'];
  }

  return ['tc', 'tc'];
};
